import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  DataTableModule, SharedModule, ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule,
  ChartModule, DropdownModule
} from 'primeng/primeng';

import { StockRoutingModule } from './stock-routing.module';
import { StockService } from './stock.service';
import { StockSearchService } from './stock-search.service';
import { StockComponent } from './stock.component';
import { StockSearchComponent } from '../stock-search/stock-search.component';

@NgModule({
  imports: [
    CommonModule,
    StockRoutingModule,
    FormsModule,
    DataTableModule, SharedModule,
    ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule,
    ChartModule, DropdownModule
  ],
  declarations: [StockComponent, StockSearchComponent],
  exports : [
    StockSearchComponent
  ],
  providers: [StockService, StockSearchService]
})
export class StockModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/stock/stock.module.ts